import React, { useEffect } from "react";
import { useErrorNotification } from "../../contexts/ErrorNotificationContext";

const NotFound: React.FC = () => {
  const { showWarning } = useErrorNotification();

  useEffect(() => {
    showWarning(
      "Page Not Found",
      "The page you're looking for doesn't exist.",
      "Please check the URL or navigate to a valid page."
    );
  }, [showWarning]);

  return (
    <>
      <div style={{ textAlign: "center" }} className="m-xsmall-top-2">
        <div className="m-xsmall-top-1">Page not found. Please check the URL or navigate to a valid page.</div>
      </div>
    </>
  );
};

export default NotFound;